import { orderBy, unionBy } from 'lodash';
import { capList } from './EngagementInsightCard.helper';
export var getIncompleteAssignmentCount = function (student) { return student.totalAssignments - student.totalAssignmentsComplete; };
export var getAtRiskStudents = function (students) { return unionBy(students, 'userId').filter(function (student) { return student.isAtRiskStudent; }); };
export var getDisplayedAtRiskStudents = function (students) {
    return capList(orderBy(getAtRiskStudents(students), getIncompleteAssignmentCount, 'desc'));
};
